import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {List as RmwcList} from '@rmwc/list'
import '@rmwc/list/styles'

const StyledRmwcList = styled(RmwcList)`
  &&& {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: 14px;
  }
`

const List = ({children, ...otherProps}) => <StyledRmwcList {...otherProps}>{children}</StyledRmwcList>

List.propTypes = {
  avatarList: PropTypes.bool,
  dense: PropTypes.bool,
  nonInteractive: PropTypes.bool,
  onAction: PropTypes.func,
  twoLine: PropTypes.bool,
  vertical: PropTypes.bool,
  wrapFocus: PropTypes.bool,
  children: PropTypes.any
}

export {List}
